import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AuditoresLista } from "../../models/auditores_lista";
import { IGetAllAuditorAuditoresUseCase } from "../../../presentation/useCases/read/get_all_auditor_auditores_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";
import { AuditorlListaFilter } from "../../models/auditor_auditores_filter";


// GetAllAuditorAuditoresServicoUseCase


export class GetAllAuditorAuditoresServicoUseCase
  extends BasePaginatedUseCase<AuditoresLista>
  implements IGetAllAuditorAuditoresUseCase {
  constructor(private readonly repository: IAuditorRepository) {
    super();
  }

  async getAllListagemAuditores(
    filter: AuditorlListaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdAuditor === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllListagemAuditores(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
